module.exports = __webpack_public_path__ + "img/fond-pythagore.18e24182.png";